// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 239) return "static/chunks/239-e331b55262324bcc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "7fcd2e1ed3f2b031" + ".js";
};